import React from 'react';
import { Form, FormProps, FormRenderProps } from 'react-final-form';
import { Box, Grid } from '@mui/material';

import { MembershipActivityTypename } from '@occc/graphql';
import { OnChange } from '@occc/ui-forms';

import { Button, Typography } from '@occc/ui-design-system';
import { KeyboardDatePicker, Select } from '@occc-app/design-system';

import {
  membershipActivityFilterOptions,
  pointChangeTypeFilterOptions,
} from './membership-activity.constants';
import { MembershipActivityFilterFormValues } from './membership-activity.types';

export type MembershipActivityFilterFormProps = {
  onSubmit: FormProps<MembershipActivityFilterFormValues>['onSubmit'];
  onReset: () => void;
  initialValues: MembershipActivityFilterFormValues;
};

export const MembershipActivityFilterForm: React.FC<MembershipActivityFilterFormProps> = ({
  onSubmit,
  onReset,
  initialValues,
}) => {
  const renderForm: FormRenderProps<MembershipActivityFilterFormValues>['render'] =
    React.useCallback(
      ({ handleSubmit, form, values }: FormRenderProps<MembershipActivityFilterFormValues>) => {
        const reset = () => {
          form.reset();
          onReset();
        };

        return (
          <form onSubmit={handleSubmit}>
            <Box p={3}>
              <Typography gutterBottom>Transaction Date</Typography>
              <Grid container spacing={2}>
                <Grid item xs={12} sm={6}>
                  <KeyboardDatePicker
                    label='Start Date'
                    name='startDate'
                    maxDate={values?.endDate || undefined}
                  />
                </Grid>
                <Grid item xs={12} sm={6}>
                  <KeyboardDatePicker
                    label='End Date'
                    name='endDate'
                    minDate={values?.startDate || undefined}
                  />
                </Grid>
                <Grid item xs={12}>
                  <Select
                    defaultValue='any'
                    name='type'
                    label='Transaction Type'
                    data={membershipActivityFilterOptions}
                  />
                  <OnChange name='type'>
                    {(type: MembershipActivityFilterFormValues['type']) => {
                      if (type !== MembershipActivityTypename.PointChange) {
                        form.change('pointChangeType', 'any');
                      }
                    }}
                  </OnChange>
                </Grid>
                {values?.type === MembershipActivityTypename.PointChange && (
                  <Grid item xs={12}>
                    <Select
                      defaultValue='any'
                      name='pointChangeType'
                      label='Point Change Type'
                      data={pointChangeTypeFilterOptions}
                    />
                  </Grid>
                )}
              </Grid>
            </Box>
            <Box display='flex' justifyContent='flex-end' px={3} pb={2}>
              <Button size='small' color='error' onClick={reset}>
                Reset
              </Button>
              <Button type='submit' size='small' color='primary'>
                Apply
              </Button>
            </Box>
          </form>
        );
      },
      [onReset],
    );
  return (
    <Form<MembershipActivityFilterFormValues>
      onSubmit={onSubmit}
      render={renderForm}
      initialValues={initialValues}
    />
  );
};
